import { getSpaceOverviewRoute } from '@confluence/ssr-app/entry-points/routes.ts';

import { SpaceOverviewRouteComponent } from './SpaceOverviewRouteComponent.tsx';
import type { RouteMatch } from '@confluence/route/entry-points/Route.ts';

export const SpaceOverviewRoute: {
	(match: RouteMatch): React.JSX.Element;
	NAVIGATION_PARAMS({ params: { spaceKey }, query: { mode } }: RouteMatch): {
		Screen: {
			screenEvent: {
				name: string;
				id: string;
				attributes: {
					isGlobalMode: boolean;
					navdexPointType: string;
					spaceKey: string;
				};
			};
			pageState: {
				spaceKey: string;
				contentId: any;
				routeName: string;
				contentType: string;
			};
		};
		MainLayout: {
			navView: string;
			spaceKey: string;
			isViewPage: boolean;
		};
	};
} = getSpaceOverviewRoute(SpaceOverviewRouteComponent);
